module.exports = __webpack_public_path__ + "static/SNYDER-logo-3da78a659febe725f38878367d111ebd.png";